import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
import "../../styles.scss";
import { useUser } from '../../utils/userContext';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import useCountryCodes from '../../utils/useCountryCodes';
import useConfiguration from '../../utils/ConfigurationContext';


export default function Submitclaims() {
    const [file, setFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const { user } = useUser();
    const [showModal, setShowModal] = useState(false);
    const [claims, setClaims] = useState([]);
    const [totalClaims, setTotalClaims] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);
    const [approvedCount, setApprovedCount] = useState(0);
    const [rejectedCount, setRejectedCount] = useState(0);
    const [claimedAmount, setClaimedAmount] = useState(0);
    const [fileData, setFileData] = useState([]);
    const config = useConfiguration();
    const hasFetchedRef = useRef(false);
    const [currencySymbol, setCurrencySymbol] = useState('');
    const [employees, setEmployees] = useState([]);
    const [approvedByOptions, setApprovedByOptions] = useState([]);
    const [formData, setFormData] = useState({
        Category: "",
        Description: "",
        BillingStartDate: moment().format("DD-MM-YYYY"),
        BillingEndDate: moment().format("DD-MM-YYYY"),
        CostDetails: "",
        ClaimAmount: "",
        currencySymbol: "",
        Status: "Pending",
        TypeOfCategory: "",
        AmountInWords: "",
        PaidBy: "",
        PaidTo: "",
        ApprovedBy: ""

    });
    const token = localStorage.getItem("token");
    const handleErrors = useHandleErrors();
    const { currencySymbols } = useCountryCodes();

    const options = currencySymbols.map((country) => ({
        value: country.value,
        label: `${country.value} (${country.label})`,
    }));

    const categoryOptions = config?.expenseManagement?.categoryTypes?.map(category => ({
        value: category,
        label: category,
    }));

    const categoryTypeOptions = [
        { value: "Expenses", label: "Expenses" },
        { value: "Claims", label: "Claims" },
    ];


    useEffect(() => {
        const fetchData = async () => {
            if (user && user?.EmployeeId) {
                const path = `/getSubmitClaimsDetails?employeeId=${user.EmployeeId}`;
                const URL = process.env.REACT_APP_BE_URL + path;
                try {
                    const data = await axios.get(URL, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    if (data.status === 200) {
                        setClaims(data.data.listSubmitClaims);

                        // Calculate counts and amounts
                        const total = data.data.listSubmitClaims?.length;
                        const pending = data.data.listSubmitClaims?.filter(claim => claim.Status === 'Pending')?.length;
                        const approved = data.data.listSubmitClaims?.filter(claim => claim.Status === 'Approved')?.length;
                        const rejected = data.data.listSubmitClaims?.filter(claim => claim.Status === 'Rejected')?.length;

                        let detectedCurrencySymbol = '';

                        const extractNumericValue = (claimAmount) => {
                            const numericClaimAmount = claimAmount.replace(/[^\d.-]/g, '');
                            return parseFloat(numericClaimAmount.replace(/,/g, ''));
                        };

                        const extractCurrencySymbol = (claimAmount) => {
                            const symbol = claimAmount.replace(/[\d.,-]/g, '').trim();
                            return symbol.length > 0 ? symbol : null;
                        };

                        // Filter only "Approved" claims
                        const approvedClaims = data.data.listSubmitClaims?.filter(claim => claim.Status === 'Approved');

                        // Calculate total approved amount
                        const approvedClaimAmount = approvedClaims.reduce((sum, claim, index) => {
                            if (index === 0) {
                                detectedCurrencySymbol = extractCurrencySymbol(claim.ClaimAmount);
                            }

                            const claimCurrencySymbol = extractCurrencySymbol(claim.ClaimAmount) || detectedCurrencySymbol;

                            if (!detectedCurrencySymbol && claimCurrencySymbol) {
                                detectedCurrencySymbol = claimCurrencySymbol;
                            }

                            const numericClaimAmount = extractNumericValue(claim.ClaimAmount);
                            return sum + numericClaimAmount;
                        }, 0);

                        // Set currency symbol and claim amounts
                        setCurrencySymbol(detectedCurrencySymbol);
                        setClaimedAmount(approvedClaimAmount);
                        setTotalClaims(total); // Total number of claims
                        setPendingCount(pending);
                        setApprovedCount(approved);
                        setRejectedCount(rejected);

                        console.log("pendingCount", pending, total);
                    } else {
                        handleErrors(data);
                    }
                } catch (error) {
                    if (error.response) {
                        if (error.response.status === 404) {
                            // Handle 404 status code separately
                            setClaims([]);
                        } else {
                            handleErrors(error.response);
                        }
                    } else {
                        toast.error("Something went wrong. Please try again later.", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        if (!hasFetchedRef.current) {
            fetchData();
            hasFetchedRef.current = true;
        }
    }, [user]);


    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const activeEmployees = response.data.onboardEmployeeDetails.filter(emp => emp.Status === 'Active');
                setEmployees(activeEmployees);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };
    

    // const assignToOptions = employees
    //     .map((emp) => ({
    //         value: emp.OfficialEmail,
    //         label: `${emp.OfficialEmail}`,
    //     }));

    useEffect(() => {
        if (employees && employees.length > 0) {
            const options = employees.map((emp) => ({
                value: emp.OfficialEmail,           // or emp.id if needed
                label: emp.OfficialEmail            // or `${emp.FirstName} ${emp.LastName}`
            }));
            setApprovedByOptions(options);
        }
    }, [employees]);

    useEffect(() => {
        fetchEmployees();
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevState => {
            let updatedValue = value;
            let amountInWords = prevState.AmountInWords;

            // If the input field is ClaimAmount, ensure only numeric values are allowed
            if (name === "ClaimAmount") {
                const numericValue = value.replace(/[^0-9]/g, ""); // Keep only numbers
                updatedValue = numericValue;
                amountInWords = numericValue ? numberToWords(parseInt(numericValue, 10)) : "";
            }

            return {
                ...prevState,
                [name]: updatedValue,
                AmountInWords: amountInWords,
            };
        });
    };


    // Function to convert number to words
    const numberToWords = (num) => {
        const ones = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
            "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
            "Seventeen", "Eighteen", "Nineteen"
        ];
        const tens = [
            "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
        ];

        if (num === 0) return "Zero";

        const convert = (n) => {
            if (n < 20) return ones[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
            if (n < 1000) return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convert(n % 100) : "");
            if (n < 1000000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
            return convert(Math.floor(n / 1000000)) + " Million" + (n % 1000000 ? " " + convert(n % 1000000) : "");
        };

        return convert(num);
    };

    const handleClick = () => {
        document.querySelector('input[name="BillingStartDate"]').focus();
    };

    const handleEvent = (event, picker) => {
        if (picker && picker.startDate && picker.endDate) {
            setFormData(prevState => ({
                ...prevState,
                BillingStartDate: picker.startDate.format("DD-MM-YYYY"),
                BillingEndDate: picker.endDate.format("DD-MM-YYYY"),
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const missingFields = [];

        if (!formData.TypeOfCategory) {
            missingFields.push("Type Of Category");
        }

        if (!formData.Category) {
            missingFields.push("Category");
        }
        if (!formData.currencySymbol) {
            missingFields.push("Currency Symbol");
        }
        if (!formData.BillingStartDate) {
            missingFields.push("Billing Start Date");
        }
        if (!formData.BillingEndDate) {
            missingFields.push("Billing End Date");
        }
        if (!formData.ClaimAmount) {
            missingFields.push("Claim Amount");
        }
        if (!uploadedFiles || uploadedFiles.length === 0) {
            missingFields.push("Document");
        }
        if (formData.TypeOfCategory === "Expenses") {
            if (!formData.PaidBy) {
                missingFields.push("Paid By");
            }
            if (!formData.PaidTo) {
                missingFields.push("Paid To");
            }
            if (!formData.ApprovedBy) {
                missingFields.push("Approved By");
            }
        }
        if (missingFields.length > 0) {
            toast.error(`Please fill in the following required fields: ${missingFields.join(", ")}`, {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }

        const data = new FormData();
        const fullClaimAmount = `${formData.currencySymbol?.split('-')[0]} ${formData.ClaimAmount}`;
        uploadedFiles.forEach((file, index) => {
            data.append('ClaimDocument', new Blob([fileData[index]], { type: file.type }), file.name);
        });
        data.append('ClaimAmount', fullClaimAmount);
        data.append('EmployeeId', user?.EmployeeId);
        data.append('EmailId', user?.OfficialEmail);
        data.append('SubmittedBy', user?.FirstName);

        // Format the BillingStartDate and BillingEndDate to 'YYYY-MM-DD'
        data.append('BillingStartDate', moment(formData.BillingStartDate, "DD-MM-YYYY").format("YYYY-MM-DD"));
        data.append('BillingEndDate', moment(formData.BillingEndDate, "DD-MM-YYYY").format("YYYY-MM-DD"));

        Object.keys(formData).forEach((key) => {
            if (key !== 'ClaimAmount' && key !== 'BillingStartDate' && key !== 'BillingEndDate' && key !== 'EmployeeId' && key !== 'SubmittedBy' && key !== 'EmailId') {
                data.append(key, formData[key]);
            }
        });

        try {
            const path = "/submitClaimsV2";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 200) {
                setShowModal(true);
                setFormData({
                    Category: "",
                    Description: "",
                    BillingStartDate: moment().format("YYYY-MM-DD"),
                    BillingEndDate: moment().format("YYYY-MM-DD"),
                    CostDetails: "",
                    EmailId: user?.OfficialEmail,
                    ClaimAmount: "",
                    Status: "Pending",
                    SubmittedBy: user?.FirstName,
                    EmployeeId: user?.EmployeeId,
                    TypeOfCategory: "",
                    AmountInWords: "",
                    PaidBy: "",
                    PaidTo: "",
                    ApprovedBy: ""
                });
                setUploadedFiles([]);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };


    const handleCloseModal = () => {
        setShowModal(false);

    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = () => {
        if (file) {
            // Store the original file directly instead of reading as binary string
            setUploadedFiles((prevFiles) => [...prevFiles, file]);
            setFileData((prevData) => [...prevData, file]); // Store the actual file object
            setFile(null);
        }
    };

    const handleDelete = (fileIndex) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, index) => index !== fileIndex));
        setFileData((prevData) => prevData.filter((_, index) => index !== fileIndex));
    };
    const handleCancel = (e) => {
        e.preventDefault();
        setFormData({
            Category: "",
            Description: "",
            BillingStartDate: moment().format("DD-MM-YYYY"),
            BillingEndDate: moment().format("DD-MM-YYYY"),
            CostDetails: "",
            EmailId: user?.OfficialEmail,
            ClaimAmount: "",
            Status: "Pending",
            SubmittedBy: user?.FirstName,
            EmployeeId: user?.EmployeeId,
            TypeOfCategory: "",
            AmountInWords: "",
            PaidBy: "",
            PaidTo: "",
            ApprovedBy: ""
        })
        setUploadedFiles([])
    };

    const ClearIndicator = () => null;


    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Claims</h3>
                        </div>
                        <div className="col-auto"><Link to={'/SubmitTimesheet'} data-extra-toggle="tab" data-target="#timesheet-pan" className="btn btn-primary mt-lg-0 mt-4"><i className="ri-calendar-schedule-fill"></i> Timesheet</Link></div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h5 class="title">Submit Claims <small class="float-right">Employee ID - <span>{user?.EmployeeId}</span></small></h5>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label for="TypeOfCategory" className="required">Type of Category</label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="TypeOfCategory"
                                                    value={
                                                        categoryTypeOptions?.find(
                                                            (option) => option.value === formData.TypeOfCategory
                                                        ) || null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            TypeOfCategory: selectedOption ? selectedOption.value : "",
                                                        })
                                                    }
                                                    options={categoryTypeOptions}
                                                    components={{ ClearIndicator }}
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label for="Category" className="required">Category</label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="Category"
                                                    value={
                                                        categoryOptions?.find(
                                                            (option) => option.value === formData.Category
                                                        ) || null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            Category: selectedOption ? selectedOption.value : "",
                                                        })
                                                    }
                                                    options={categoryOptions}
                                                    components={{ ClearIndicator }}
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="billingDateRange" className="required">
                                                    Billing Date
                                                </label>
                                                <div className="input-group dateRange">
                                                    <DateRangePicker
                                                        initialSettings={{
                                                            startDate: moment(
                                                                formData.BillingStartDate,
                                                                "DD-MM-YYYY"
                                                            ).toDate(),
                                                            endDate: moment(
                                                                formData.BillingEndDate,
                                                                "DD-MM-YYYY"
                                                            ).toDate(),
                                                            locale: {
                                                                format: "DD-MM-YYYY",
                                                            },
                                                        }}
                                                        onEvent={handleEvent}
                                                    >
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="BillingStartDate"
                                                            placeholder="Select Date"
                                                            value={`${formData.BillingStartDate} - ${formData.BillingEndDate}`}
                                                            onChange={handleChange}
                                                        />
                                                    </DateRangePicker>
                                                    <div className="input-group-append">
                                                        <span
                                                            className="input-group-text bg-white"
                                                            onClick={handleClick}
                                                        >
                                                            <i className="ri-calendar-2-line"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label for="costDetails">Cost Details</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="CostDetails"
                                                    value={formData.CostDetails}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label for="ClaimAmount" className="required">Claim Amount</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="currencySymbol"
                                                            value={
                                                                options.find((option) => `${option.value}-${options.indexOf(option)}` === formData.currencySymbol) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    currencySymbol: selectedOption ? selectedOption.value : '',
                                                                })
                                                            }
                                                            options={options.map((option, index) => ({
                                                                ...option,
                                                                value: `${option.value}-${index}`, // Add the index to make the value unique
                                                            }))}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ClaimAmount"
                                                        value={formData.ClaimAmount}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label
                                                    htmlFor="ApprovedBy"
                                                    className={formData.TypeOfCategory === 'Expenses' ? 'required' : ''}
                                                >
                                                    Approved By
                                                </label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="ApprovedBy"
                                                    value={
                                                        approvedByOptions.find(option => option.value === formData.ApprovedBy) || null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            ApprovedBy: selectedOption ? selectedOption.value : '',
                                                        })
                                                    }
                                                    options={approvedByOptions}
                                                    placeholder="Select..."
                                                    isClearable
                                                    components={{ ClearIndicator }}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        control: base => ({ ...base, zIndex: 1 })
                                                    }}
                                                />
                                            </div>
                                        </div>





                                    </div>
                                    <div className="form-group mt-2">
                                        <label htmlFor="AmountInWords">Amount in Words</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="AmountInWords"
                                                value={formData.AmountInWords}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="PaidBy" className={formData.TypeOfCategory === 'Expenses' ? 'required' : ''}>Paid By</label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="PaidBy"
                                                        value={formData.PaidBy}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="PaidTo" className={formData.TypeOfCategory === 'Expenses' ? 'required' : ''}>Paid To</label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="PaidTo"
                                                        value={formData.PaidTo}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="Document" className="required">
                                                    Document
                                                </label>
                                                <div className="d-flex align-items-center">
                                                    <div className="custom-file mr-2">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id="Document"
                                                            onChange={handleFileChange}
                                                        />
                                                        <label className="custom-file-label" htmlFor="uploadEmpofferletter">
                                                            {file ? file.name : 'Choose a file'}
                                                        </label>
                                                    </div>
                                                    <button className="btn btn-secondary" onClick={handleUpload}>
                                                        Upload
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="container-fluid my-2 px-0">
                                                <div className="row">
                                                    {uploadedFiles?.map((file, index) => (
                                                        <div key={index} className="col-6 mb-2">
                                                            <button
                                                                className="btn btn-link text-danger btn-action"
                                                                type="button"
                                                                onClick={() => handleDelete(index)}
                                                            >
                                                                <i className="ri-delete-bin-6-line" />
                                                            </button>
                                                            <span>{file.name}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label for="description">Description</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="7"
                                                    name="Description"
                                                    value={formData.Description}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body ">
                                    <span><i className="ri-receipt-fill"></i></span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h4 className="mb-2">Claims History</h4>
                                    <p>Quick summary of all submitted claims.</p>
                                    <div className="row text-center">
                                        <div className="col-lg-12 col-md-12 border-bottom">
                                            <div>
                                                <label>Total Claims</label>
                                                <h4>{`${totalClaims}`}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4">
                                            <div className="claim-history-box pending-count">
                                                <label>Pending</label>
                                                <h4 className="text-warning">{pendingCount}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4 border-right border-left">
                                            <div className="claim-history-box approved-count">
                                                <label>Approved</label>
                                                <h4 className="text-success">{approvedCount}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4">
                                            <div className="claim-history-box rejected-count">
                                                <label>Rejected</label>
                                                <h4 className="text-light">{rejectedCount}</h4>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 border-top">
                                            <div className="claim-history-box claimed-amount">
                                                <label>Amount Claimed</label>
                                                <h4 className="text-info">{`${claimedAmount.toFixed(2)}`}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center">
                    <button type="reset" className="btn btn-light" onClick={handleCancel}>Clear</button>
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Submit <i className="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Your claim or expense has been submitted successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}